export const API_BASE_URL =
  (process.env.REACT_APP_API_URL || 'http://localhost:9000').replace(/\/+$/, '');


export const WS_BOT_URL = String(process.env.REACT_APP_WS_BOT_URL || '').trim();

export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === '1';

function envBool(v, fallback = false) {
  const s = String(v ?? '').trim().toLowerCase();
  if (!s) return fallback;
  if (['1', 'true', 'yes', 'y', 'on'].includes(s)) return true;
  if (['0', 'false', 'no', 'n', 'off'].includes(s)) return false;
  return fallback;
}

export const ENVIRONMENT_DEV = envBool(
  process.env.REACT_APP_ENVIRONMENT_DEV,
  false
);

export const ON_CALLBACK = window.location.pathname.startsWith('/auth/callback');
export const HAS_CODE = new URLSearchParams(window.location.search).has('code');
